<template>
    <v-container class="content-container">
        <v-row>
            <v-col>

                <!-- Page title -->
                <div class="page-heading mb-4">
                    {{ $t(`ZakljucekPogodbe.Title`) }}
                </div>

                <!-- Info text -->
                <div class="page-heading__text mb-14">
                    <div>
                        {{ $t(`ZakljucekPogodbe.FindContractText`) }}
                    </div>
                </div>

                <!-- Content -->
                <div v-if="!dokoncanjePogodbeStore.FormState.IsSisbonSuccess">

                    <!-- Filters -->
                    <div>
                        <v-row>
                            <!-- Search -->
                            <v-col class="v-col-12 v-col-md-6">
                                <label class="form-label">
                                    {{ $t(`ZakljucekPogodbe.ContractNumber`) }}
                                </label>

                                <TextInputUppercase v-model="dokoncanjePogodbeStore.FormState.Search" variant="outlined"
                                    :maxLength="8">
                                </TextInputUppercase>
                            </v-col>

                            <v-col class="d-flex align-center">
                                <v-btn @click="dokoncanjePogodbeStore.getPogodbaByNumber" flat size="large"
                                    class="btn btn--primary-fill">
                                    {{ $t(`ZakljucekPogodbe.BtnSearch`) }}
                                </v-btn>

                            </v-col>
                        </v-row>
                    </div>
                </div>

                <!-- Notification error -->
                <div class="notification notification--warning"
                    v-if="dokoncanjePogodbeStore.FormState.ErrorText.length > 0 ? true : false">
                    {{ dokoncanjePogodbeStore.FormState.ErrorText }}
                </div>

            </v-col>
        </v-row>
    </v-container>
</template>

<script setup lang="ts">
import { useDokoncanjePogodbeStore } from "@/app/store/app/contract-completion/store";
import TextInputUppercase from "@components/text-input-uppercase.vue";

const dokoncanjePogodbeStore = useDokoncanjePogodbeStore();
dokoncanjePogodbeStore.$reset();

// dokoncanjePogodbeStore.Steps.Pogodba.disabled = true;
dokoncanjePogodbeStore.Steps.Dokumentacija.disabled = true;
dokoncanjePogodbeStore.Steps.Identifikacija.disabled = true;
dokoncanjePogodbeStore.Steps.Zakljucek.disabled = true;
</script>